module.exports = __webpack_public_path__ + "img/brand-07.141f6cfa.png";